const moduloHorasExtras = {
  agGrid: {
    paginacion: 15,
    id: 'myGrid',
    // class: 'ag-theme-material mt-3',
    class: 'ag-theme-alpine',
    style: {
      width: '100%',
      height: '400px'
    }
  },
  url: {
    parametrizacion: {
      feriado: {
        getAll: 'holidays',
        create: 'holidays',
        update: 'holidays/',
        delete: 'holidays/',
        getAllLocalizaciones: 'holidays/localities'
      },
      porcentajeRecarga: {
        getAll: 'extra-hours/configurations',
        create: 'extra-hours/configurations',
        update: 'extra-hours/configurations/',
        delete: 'extra-hours/configurations/',
      },
      empleado: {
        getAll: 'extra-hours/employees',
        getAllEmpleados: 'employees/fabril',
        create: 'extra-hours/employees',
        update: 'extra-hours/employees/',
        cargaMasiva: 'extra-hours/employees/upload',
        delete: 'extra-hours/employees/',
      },
      fechaCorte: {
        getAll: 'extra-hours/cut-off-date',
        create: 'extra-hours/cut-off-date',
        update: 'extra-hours/cut-off-date/',
        delete: 'extra-hours/cut-off-date/',
      },
      minutosGracia: {
        getAll: 'extra-hours/minutes',
        create: 'extra-hours/minutes',
        update: 'extra-hours/minutes/',
        delete: 'extra-hours/minutes/',
      },
      localidadTurno: {
        getAll: 'extra-hours/localions-shifts',
        create: 'extra-hours/localions-shifts',
        update: 'extra-hours/localions-shifts/',
        delete: 'extra-hours/localions-shifts/',
      },
      reeplazoEmpleado: {
        getAll: 'employees/replacements',
        create: 'employees/replacements',
        update: 'employees/replacements/',
        delete: 'employees/replacements/',
      },
      tipoTurno: {
        getAll: 'extra-hours/type-shifts',
        create: 'extra-hours/type-shifts',
        update: 'extra-hours/type-shifts/',
        delete: 'extra-hours/type-shifts/',
      },
    },
    horasExtras: {
      cargaTurno: {
        getAll: 'extra-hours/employee-shifts/',
        loadShifts: 'extra-hours/employee-shifts/',
      },
      modificacionMarcacion: {
        getAll: 'extra-hours/marcaciones/employees/',
        getAllEmployees: 'employees',
        getAllEmployeesByDepartment: 'employees/department/',
        getAllDepartment: 'caracteristica/departamento',
        update: 'extra-hours/marcaciones/',
        create: 'extra-hours/marcaciones',
        delete: 'extra-hours/marcaciones/',
        report: 'extra-hours/marcaciones/reporte?',
        reportReplica: 'extra-hours/marcaciones/reporteReplica?'
      },
      replicaMarcacion: {
        getAllByEmployees: 'extra-hours/marcaciones-originales/',
        getAllByDepartment: 'extra-hours/marcaciones-originales',
      },
      verificacionTalentoHumano: {
        getAllWeekly: 'extra-hours/weekly',
        getAllCalculateRRHH: 'extra-hours/calculate',
        getAllSegundaVerificacion: 'extra-hours/authorize',
        segundaVerificacion: 'extra-hours/authorize',
        getAllCalculate: 'extra-hours/calculate',
        getAllCalculateReport: 'extra-hours/calculate/report',
        getAllMonthly: 'extra-hours/monthly',
        procesarHorasExtras: 'extra-hours',
      },
    }
  },
  button: {
    buttonsCss: {
      primary: 'btn btn-primary btn-block',
      secondary: 'btn btn-secondary btn-block',
      success: 'btn btn-success btn-block',
      danger: 'btn btn-danger btn-block',
      warning: 'btn btn-warning btn-block',
      info: 'btn btn-info btn-block',
      light: 'btn btn-light btn-block',
      dark: 'btn btn-dark btn-block',

      primaryOutline: 'btn btn-outline-primary btn-block',
      secondaryOutline: 'btn btn-outline-secondary btn-block',
      successOutline: 'btn btn-outline-success btn-block',
      dangerOutline: 'btn btn-outline-danger btn-block',
      warningOutline: 'btn btn-outline-warning btn-block',
      infoOutline: 'btn btn-outline-info btn-block',
      lightOutline: 'btn btn-outline-light btn-block',
      darkOutline: 'btn btn-outline-dark btn-block'
    },
    buttonsNombre: {
      //*GLOBAL
      editar: 'Editar',
      eliminar: 'Eliminar',
      nuevo: 'Nuevo',
      agregar: 'Agregar',

      //*SECCION DE MENU
      agregarN2: 'Agregar Nivel 2',
      agregarN3: 'Agregar Nivel 3',
      agregarRol: 'Agregar Rol',
      agregarFeriado: 'Agregar Feriado',
      agregarPorcentajeRecarga: 'Agregar Porcentaje de Recarga',
      agregarEmpleado: 'Agregar Parámetro de Empleado',
      agregarFechaCorte: 'Agregar Fecha de Corte',
      agregarTurno: 'Agregar Turnos',
      agregarMinutosGracia: 'Agregar Minutos de Gracia',
      agregarLocalidadTurno: 'Agregar Localidad Turno',
      agregarReemplazoEmpleado: 'Agregar Reemplazo Empleado',
      agregarTipoTurno: 'Agregar Tipo Turno',
      agregarModificacionMarcaciones: 'Agregar Marcación',

      agregarEstado: 'Agregar Estado',
      agregarSesion: 'Agregar Sesión',
      agregarUsuario: 'Agregar Usuario',
      agregarMaterial: 'Agg Material',
      agregarPortafolio: 'Agregar Portafolio',
      agregarAutorizacion: 'Agregar Autorización',
      agregarAplicacion: 'Agregar Aplicación',

      agregarCampo: 'Agregar',
      guardar: 'Guardar',
      mostrar: 'Mostrar seleccion',
      regresar: 'Regresar',
      continuar: 'Continuar',
      buscar: 'Buscar',
      procesar: 'Procesar',
    }
  },
  mensajes: {
    eliminar: '¿Esta seguro que desea eliminar el siguiente elemento?',
    guardar: '¿Esta seguro que desea guardar el siguiente elemento?',
    actualizar: '¿Esta seguro que desea actualizar el siguiente elemento?',
    datoGuardado: 'Se guardo corectamente..!!',
    completeInformacion: 'Complete la informacion requerida',
    mensajeAdvertencia: 'La Órden contiene un solo elemento en el detalle desea eliminar la órden completa?',
    guardarDatorForm: 'Desea guardar los datos del formulario',
    mjsProcesar: 'Desea procesar los datos del formulario',
    mjsCampo: 'Al menos debe contener otro Campo "Articulo Alternativo"',
    mjsCampo1: 'Al menos debe contener otro Campo "CodigoBarra"',
    mjsCampo2: 'Al menos debe contener otro Campo',
    mjsCampoAdv: 'Obligatorio Campo Cantidad',
    mjsFilasCorrectas: 'Filas Correctas',
    mjsFilasIncorrectas: 'Filas Incorrectas',
    procesar: '¿Esta seguro que desea procesar el siguiente formulario?'
  },
  titulos: {
    parametrizacionFeriados: {
      titulo: 'Feriado',
      modulo: 'Parametrización',
      tituloCardListar: 'Listar Feriados',
      tituloCardGuardar: 'Guardar Feriado',
      tituloCardEditar: 'Editar Feriado',
    },
    parametrizacionPorcentajeRecarga: {
      titulo: 'Porcentaje de Recarga',
      modulo: 'Parametrización',
      tituloCardListar: 'Listar Porcentajes de Recarga',
      tituloCardGuardar: 'Guardar Porcentaje de Recarga',
      tituloCardEditar: 'Editar Porcentaje de Recarga',
    },
    parametrizacionEmpleados: {
      titulo: 'Parámetro de Empleado',
      modulo: 'Parametrización',
      tituloCardListar: 'Listar Parámetros de Empleados',
      tituloCardGuardar: 'Guardar Parámetro de Empleado',
      tituloCardEditar: 'Editar Parámetro de Empleado',
    },
    parametrizacionFechaCorte: {
      titulo: 'Fecha de Corte',
      modulo: 'Parametrización',
      tituloCardListar: 'Listar Fechas de Corte',
      tituloCardGuardar: 'Guardar Fecha de Corte',
      tituloCardEditar: 'Editar Fecha de Corte',
    },
    horasExtrasCargarTurno: {
      titulo: 'Carga Turnos',
      modulo: 'Horas Extras',
      tituloCardListar: 'Listar Turnos',
      tituloCardGuardar: 'Guardar Turnos',
      tituloCardEditar: 'Editar Turnos',
    },
    horasExtrasModificacionMarcaciones: {
      titulo: 'Modificación Marcaciones',
      modulo: 'Horas Extras',
      tituloCardListar: 'Listar Marcaciones',
      tituloCardGuardar: 'Guardar Marcaciones',
      tituloCardEditar: 'Editar Marcaciones',
    },
    horasExtrasReplicaMarcacionesEmpleado: {
      titulo: 'Replica Marcaciones Empleado',
      modulo: 'Horas Extras',
      tituloCardListar: 'Listar Marcaciones',
      tituloCardGuardar: 'Guardar Marcaciones',
      tituloCardEditar: 'Editar Marcaciones',
    },

    horasExtrasReplicaMarcacionesDepartamento: {
      titulo: 'Replica Marcaciones Departamento',
      modulo: 'Horas Extras',
      tituloCardListar: 'Listar Marcaciones',
      tituloCardGuardar: 'Guardar Marcaciones',
      tituloCardEditar: 'Editar Marcaciones',
    },

    horasExtrasVerificacionTalentoHumano: {
      titulo: 'Verificación Talento Humano',
      modulo: 'Horas Extras',
      tituloCardListar: 'Listar Verificación',
      tituloCardGuardar: 'Guardar Verificación',
      tituloCardEditar: 'Editar Verificación',
    },
    horasExtrasVerificacionTalentoHumanoSegundaVerificacion: {
      titulo: 'Segunda Verificación Talento Humano',
      modulo: 'Horas Extras',
      tituloCardListar: 'Listar Segunda Verificación',
      tituloCardGuardar: 'Guardar Verificación',
      tituloCardEditar: 'Editar Verificación',
    },
    parametrizacionMinutosGracia: {
      titulo: 'Minutos de Gracia',
      modulo: 'Parametrización',
      tituloCardListar: 'Listar Minutos de Gracia',
      tituloCardGuardar: 'Guardar Minutos de Gracia',
      tituloCardEditar: 'Editar Minutos de Gracia',
    },
    parametrizacionLocalidadTurno: {
      titulo: 'Localidad Turno',
      modulo: 'Parametrización',
      tituloCardListar: 'Listar Localidad Turno',
      tituloCardGuardar: 'Guardar Localidad Turno',
      tituloCardEditar: 'Editar Localidad Turno',
    },
    parametrizacionReemplazoEmpleados: {
      titulo: 'Reemplazo de Empleados',
      modulo: 'Parametrización',
      tituloCardListar: 'Listar Reemplazos',
      tituloCardGuardar: 'Guardar Reemplazo',
      tituloCardEditar: 'Editar Reemplazo',
    },
    parametrizacionTipoTurno: {
      titulo: 'Tipos de Turnos',
      modulo: 'Parametrización',
      tituloCardListar: 'Listar Tipos de Turnos',
      tituloCardGuardar: 'Guardar Tipo de Turno',
      tituloCardEditar: 'Editar Tipo de Turno',
    },
  }
}
export {moduloHorasExtras}
